{
    "name": "Custom",
    "value": "CUSTOM",
    "description": "A customised role with permissions assigned as needed"
}
